import { createSlice } from "@reduxjs/toolkit";
import { getRawMaterialCollectionList } from "../../reduxApi/admin/RawMaterialCollectionReduxApi";


const RawMaterialCollectionSlice = createSlice({
    name: 'rawMaterialCollection',
    initialState: {
        status: 'idel',
        isFiltered: false,
        rawMaterialCollection: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteRawMaterialCollectionAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.rawMaterialCollection.findIndex((item) => {
                    const material = item?.rawMaterialCollection || item?.rawMatetialCollection || item;
                    return material?.ROWID === id;
                });
                if (index !== -1) {
                    state.rawMaterialCollection.splice(index, 1);
                }
            });
        },
        updateRawMaterialCollectionAction: (state, action) => {
            const index = state.rawMaterialCollection.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.rawMaterialCollection.splice(index, 1, { rawMatetialCollection: action.payload })
            }
        },
        addRawMaterialCollectionAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.rawMaterialCollection.unshift({ rawMatetialCollection: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRawMaterialCollectionList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getRawMaterialCollectionList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("action.payload in slice", action.payload);
                state.rawMaterialCollection = action.payload;
            })
    }
})
export const { deleteRawMaterialCollectionAction, updateRawMaterialCollectionAction, addRawMaterialCollectionAction, setFilteredStatus } = RawMaterialCollectionSlice.actions
export default RawMaterialCollectionSlice.reducer
